import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
export var Breadcrumb = function Breadcrumb(props) {
  var elementType = props.elementType,
      method = props.method,
      to = props.to,
      children = props.children,
      attributes = _objectWithoutPropertiesLoose(props, ["elementType", "method", "to", "children"]);

  var ElementType = elementType || "span";

  var innerTagProps = _extends({}, attributes);

  if (to) {
    ElementType = elementType || "a";
    innerTagProps[method || ElementType === "a" && "href" || "to"] = to;
  }

  return /*#__PURE__*/React.createElement("li", {
    className: "breadcrumbs__crumb"
  }, /*#__PURE__*/React.createElement(ElementType, innerTagProps, children));
};